import { Icon } from '@sleepstation/components'
import { LinkBase } from '@sleepstation/components-base'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_JUSTIFY } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const NavLink = styled(LinkBase)`
  position: relative;
  color: white;
  text-decoration: none;
  font-size: 16px;
`

const NavLinkLabel = styled.span`
  padding: 4px;
`

const Inner = styled(VLayout).attrs({
  justify: LAYOUT_JUSTIFY.CENTER,
  align: LAYOUT_ALIGN.CENTER,
})`
  cursor: pointer;
  padding: 10px 0 6px;
  transition: background-color 0.25s ease-in-out;

  &:hover {
    background-color: #456bb3;
  }
`

const Badge = styled.div`
  position: absolute;
  top: 6px;
  left: 50%;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background-color: #ff3050;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BottomHorizontalMenuItem = ({
  linkUrl,
  iconKey,
  linkText,
  showBadge,
}) => (
  <NavLink href={linkUrl} forceOpenInSameWindow>
    <Inner>
      <Icon name={iconKey} />
      <NavLinkLabel>{linkText}</NavLinkLabel>
      {showBadge && <Badge />}
    </Inner>
  </NavLink>
)

BottomHorizontalMenuItem.propTypes = {
  linkUrl: PropTypes.string.isRequired,
  iconKey: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  showBadge: PropTypes.bool.isRequired,
}

BottomHorizontalMenuItem.defaultProps = {}

export default BottomHorizontalMenuItem
